webpackJsonp([1],{

/***/ "0ZYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_package__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__root_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs__ = __webpack_require__("OEdS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_truncate__ = __webpack_require__("tYtk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_truncate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_truncate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_octocat_png__ = __webpack_require__("8sfF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_octocat_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_octocat_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_javascript_VhChromeFix__ = __webpack_require__("4fNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_breakpoint_component__ = __webpack_require__("X157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_breakpoint_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_breakpoint_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Anchor__ = __webpack_require__("OjZm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_stepper_component__ = __webpack_require__("Bzn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_stepper_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_stepper_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VDocs',
  components: {
    VA: __WEBPACK_IMPORTED_MODULE_6__components_Anchor__["a" /* default */],
    VShowAt: __WEBPACK_IMPORTED_MODULE_5_vue_breakpoint_component__["VShowAt"],
    VHideAt: __WEBPACK_IMPORTED_MODULE_5_vue_breakpoint_component__["VHideAt"],
    VStepper: __WEBPACK_IMPORTED_MODULE_7_vue_stepper_component__["VStepper"],
    VBreakpoint: __WEBPACK_IMPORTED_MODULE_5_vue_breakpoint_component__["VBreakpoint"]
  },
  data: function data() {
    return {

      pkg: __WEBPACK_IMPORTED_MODULE_0__root_package___default.a,

      assets: {
        octocat: __WEBPACK_IMPORTED_MODULE_3__assets_images_octocat_png___default.a
      },

      markdowns: {
        props: __webpack_require__("BAuv"),
        install: __webpack_require__("yypm"),
        examples: {
          default: {
            script: __webpack_require__("LDf2"),
            template: __webpack_require__("yP6i")
          },
          programmatic: {
            template: __webpack_require__("3wBu")
          },
          vuex: {
            meta: __webpack_require__("xC3h"),
            component: {
              script: __webpack_require__("eVP5"),
              template: __webpack_require__("BVlo")
            }
          }
        }
      },

      model: {
        steps: 3,
        step: undefined,
        breakpoint: new __WEBPACK_IMPORTED_MODULE_5_vue_breakpoint_component__["Model"]()
      },

      flags: {
        debug: false,
        random: false,
        persist: true,
        production: "production" !== 'development'
      }
    };
  },
  created: function created() {
    this.vhChromeFix = undefined;
  },
  mounted: function mounted() {
    window.setTimeout(__WEBPACK_IMPORTED_MODULE_1_prismjs___default.a.highlightAll);

    this.vhChromeFix = new __WEBPACK_IMPORTED_MODULE_4__assets_javascript_VhChromeFix__["a" /* VhChromeFix */]([{ selector: '.js-vh-fix', vh: 100 }]);
  },
  destroyed: function destroyed() {
    this.vhChromeFix.destroy();
  },

  computed: {
    einyLorem: function einyLorem() {
      var lorem = '\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n      In euismod elementum ante ac volutpat. Suspendisse euismod est enim,\n      sit amet vehicula neque feugiat id. Nunc imperdiet convallis placerat.\n      Sed accumsan mauris et magna facilisis gravida. Suspendisse et justo volutpat,\n      congue libero id, vehicula sem. Maecenas nec ex imperdiet, bibendum justo vel,\n      feugiat velit. Vivamus eu maximus mi. Fusce ac metus magna.\n      ';
      if (this.model.breakpoint.noMatch) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_truncate___default()(lorem, { length: 200 });
      }
      return lorem;
    },
    minyLorem: function minyLorem() {
      var lorem = '\n      Nunc a nunc at sapien posuere consequat. Vestibulum sed maximus felis.\n      Nulla a diam sit amet nulla malesuada commodo.\n      Fusce ullamcorper tortor sed ipsum ornare suscipit eget at nulla.\n      Donec facilisis elit purus, eu tempus nunc feugiat sollicitudin.\n      Mauris ipsum ligula, faucibus sed libero vel, dignissim posuere mauris.\n      Quisque ipsum tellus, sodales ac ante sed, consequat efficitur metus.\n      Pellentesque euismod viverra orci.\n      ';
      if (this.model.breakpoint.noMatch) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_truncate___default()(lorem, { length: 190 });
      }
      return lorem;
    },
    moeLorem: function moeLorem() {
      var lorem = '\n      Aenean vel arcu mollis, feugiat ipsum vitae, sollicitudin nibh. Integer fermentum,\n      dui ut laoreet faucibus, nibh elit ultricies ipsum, sit amet placerat libero nisl id enim.\n      Quisque quis arcu nisi. Etiam interdum luctus neque, non tincidunt metus mollis vel.\n      In nec tellus non nisl commodo aliquet a a ligula. Donec semper massa nisl,\n      a tristique lectus ultrices ut. Donec ac ultricies lectus, a semper nibh. Integer tempor,\n      purus ac convallis semper.\n      ';
      if (this.model.breakpoint.noMatch) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_truncate___default()(lorem, { length: 210 });
      }
      return lorem;
    }
  }
});

/***/ }),

/***/ "3wBu":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-html\">&lt;v-stepper ref=&quot;stepper&quot; :steps=&quot;steps&quot; v-model=&quot;step&quot;&gt;&lt;/v-stepper&gt;\n\n&lt;!-- Stepper Controls --&gt;\n&lt;button type=&quot;button&quot; @click=&quot;$refs.stepper.previous()&quot;&gt;Previous&lt;/button&gt;\n&lt;button type=&quot;button&quot; @click=&quot;$refs.stepper.next()&quot;&gt;Next&lt;/button&gt;\n&lt;button type=&quot;button&quot; @click=&quot;$refs.stepper.reset()&quot;&gt;Reset&lt;/button&gt;\n</code></pre>\n";

/***/ }),

/***/ "4fNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VhChromeFix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


// https://stanko.github.io/mobile-chrome-vh-units-fix/

var VhChromeFix = function () {
  function VhChromeFix(selectors) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, VhChromeFix);

    this.selectors = selectors;

    var userAgent = navigator.userAgent.toLowerCase();
    var isAndroidChrome = /chrome/.test(userAgent) && /android/.test(userAgent);
    var isIosChrome = /crios/.test(userAgent);

    if (isAndroidChrome || isIosChrome) {
      // If we detected Chrome on Android or iOS
      // Cache elements and trigger fix on init
      this.getElements(this.selectors);
      this.fixAll();

      // Cache window dimensions
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;

      this.onResize = function () {
        // Both width and height changed (orientation change)
        // This is a hack, as Android when keyboard pops up
        // Triggers orientation change
        _this.windowWidth = window.innerWidth;
        _this.windowHeight = window.innerHeight;
        _this.fixAll();
      };

      window.addEventListener('resize', this.onResize, false);
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(VhChromeFix, [{
    key: 'getElements',
    value: function getElements() {
      var selectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


      this.elements = [];

      selectors = [].concat(selectors);

      for (var i = 0; i < selectors.length; i++) {
        // Get all elements for selector
        var selector = selectors[i].selector;
        var elements = document.querySelectorAll(selector);

        // Go through all elements for one selector to filter them
        for (var j = 0; j < elements.length; j++) {
          var offset = selectors[i].offset || 0;
          this.elements.push({
            domElement: elements[j],
            vh: selectors[i].vh,
            offset: offset
          });
        }
      }
    }
  }, {
    key: 'fixAll',
    value: function fixAll() {
      for (var i = 0; i < this.elements.length; i++) {
        var element = this.elements[i];
        var offset = element.offset;
        element.domElement.style.height = window.innerHeight * (element.vh / 100) - offset + 'px';
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      window.removeEventListener('resize', this.onResize);
    }
  }]);

  return VhChromeFix;
}();

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"vue-stepper-component","version":"1.0.0","description":"A Vue.js Stepper component","author":"Adi Sahar","main":"dist","private":true,"scripts":{"dev":"node build/dev-server.js","start":"npm run dev","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","predeploy":"npm run build","deploy":"node build/deploy.js"},"repository":{"type":"git","url":"https://github.com/adi518/vue-stepper-component"},"bugs":{"url":"https://github.com/adi518/vue-stepper-component/issues"},"dependencies":{"bootstrap":"^4.1.2","lodash.truncate":"^4.4.2","prismjs":"^1.15.0","vue":"^2.5.16","vue-analytics":"^5.12.2","vue-breakpoint-component":"^1.0.3","vue-router":"^2.7.0","vue-switch":"^1.3.0"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-loader":"^7.1.1","babel-plugin-istanbul":"^4.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.3.2","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chai":"^3.5.0","chalk":"^2.0.1","chromedriver":"^2.27.2","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","cross-env":"^5.0.1","cross-spawn":"^5.0.1","css-loader":"^0.28.0","cssnano":"^3.10.0","ejs":"^2.5.7","eslint":"^3.19.0","eslint-config-standard":"^6.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^2.0.1","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.1.3","gh-pages":"^1.2.0","html-loader":"^0.5.1","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","inject-loader":"^3.0.0","karma":"^1.4.1","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.3.1","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.2","markdown-loader":"^2.0.2","marked":"^0.4.0","mocha":"^3.2.0","nightwatch":"^0.9.12","node-sass":"^4.9.0","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^2.0.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.14","rimraf":"^2.6.0","sass-loader":"^6.0.7","selenium-server":"^3.0.1","semver":"^5.3.0","shelljs":"^0.7.6","sinon":"^2.1.0","sinon-chai":"^2.8.0","url-loader":"^0.5.8","vue-loader":"^13.0.4","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.5.16","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "8sfF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/octocat.38fdb74.png";

/***/ }),

/***/ "BAuv":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-js\">/**\n * Contains the current step value. Very similar to a\n * `value` attribute on an input. In most cases, you&#39;ll want\n * to set this as a two-way binding, using the `v-model` directive.\n * @type {Number||undefined||null}\n */\nvalue: {\n  type: Number,\n  default: 1\n},\n\n/**\n * Contains the steps count.\n * @type {Number}\n */\nsteps: {\n  type: Number,\n  default: 0\n},\n\n/**\n * Sets up the Stepper in either\n * linear or random mode.\n * @type {Boolean}\n */\nlinear: {\n  type: Boolean,\n  default: true\n},\n\n/**\n * Sync state with storage?\n * @type {Boolean}\n */\npersist: {\n  type: Boolean,\n  default: false\n},\n\n/**\n * Which Storage API to use.\n * Should be used with `persist` prop.\n * @type {String}\n */\nstorekeeper: {\n  type: String,\n  default: &#39;localStorage&#39;,\n  validator(value) {\n    return [&#39;localStorage&#39;, &#39;sessionStorage&#39;].includes(value)\n  }\n},\n\n/**\n * Add/Remove a divider to/from each Step component.\n * @type {Boolean}\n */\nwithDivider: {\n  type: Boolean,\n  default: true\n},\n\n/**\n * Steps wrapper component.\n * @type {Object}\n */\nrootComponent: {\n  type: Object,\n  default: () =&gt; VStepperRoot\n},\n\n/**\n * Sets up debug mode, which reveals\n * the actual radio-button behind each step.\n * @type {Boolean}\n */\ndebug: {\n  type: Boolean,\n  default: false\n}\n</code></pre>\n";

/***/ }),

/***/ "BVlo":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-html\">&lt;v-stepper :steps=&quot;steps&quot; v-model=&quot;step&quot;&gt;&lt;/v-stepper&gt;\n\n&lt;!-- Change routes by step --&gt;\n&lt;router-view&gt;&lt;/router-view&gt;\n</code></pre>\n";

/***/ }),

/***/ "Bzn5":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var n=t();for(var i in n)("object"==typeof exports?exports:e)[i]=n[i]}}(window,function(){return function(e){var t={};function n(i){if(t[i])return t[i].exports;var r=t[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,i){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(i,r,function(t){return e[t]}.bind(null,r));return i},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=17)}([function(e,t,n){"use strict";function i(e,t,n,i,r,o,a,s){var u,d="function"==typeof e?e.options:e;if(t&&(d.render=t,d.staticRenderFns=n,d._compiled=!0),i&&(d.functional=!0),o&&(d._scopeId="data-v-"+o),a?(u=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(a)},d._ssrRegister=u):r&&(u=s?function(){r.call(this,this.$root.$options.shadowRoot)}:r),u)if(d.functional){d._injectStyles=u;var f=d.render;d.render=function(e,t){return u.call(t),f(e,t)}}else{var c=d.beforeCreate;d.beforeCreate=c?[].concat(c,u):[u]}return{exports:e,options:d}}n.d(t,"a",function(){return i})},function(e,t,n){"use strict";n.r(t);var i=n(2),r=n.n(i);for(var o in i)"default"!==o&&function(e){n.d(t,e,function(){return i[e]})}(o);t.default=r.a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i={name:"VStep",props:{index:{type:Number,default:0},name:{type:String,default:""},active:{type:Boolean,default:!1},visited:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},withDivider:{type:Boolean,default:!1},debug:{type:Boolean,default:!0}},data:function(){return{namespace:"v-step"}},computed:{id:function(){return"".concat(this.namespace,"-").concat(this._uid,"-").concat(this.index)},displayIndex:function(){return this.index+1},classes:function(){return{"is-active":this.active,"is-visited":this.visited,"is-disabled":this.disabled}},computedName:function(){return this.name||this.id},defaultSlot:function(){return this.$slots.default||this.$scopedSlots.default},api:function(){return{displayIndex:this.displayIndex,defaultSlot:this.defaultSlot}}},methods:{handleChange:function(){this.$emit("change",this.index)}},inheritAttrs:!1};t.default=i},function(e,t,n){var i=n(20);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(15).default)("2961f72e",i,!1,{})},function(e,t,n){"use strict";n.r(t);var i=n(5),r=n.n(i);for(var o in i)"default"!==o&&function(e){n.d(t,e,function(){return i[e]})}(o);t.default=r.a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(13)),r=o(n(16));function o(e){return e&&e.__esModule?e:{default:e}}var a={name:"VStepper",components:{VStep:i.default},props:{value:{type:Number,default:1},steps:{type:Number,default:0},linear:{type:Boolean,default:!0},persist:{type:Boolean,default:!1},storekeeper:{type:String,default:"localStorage",validator:function(e){return["localStorage","sessionStorage"].includes(e)}},withDivider:{type:Boolean,default:!0},rootComponent:{type:Object,default:function(){return r.default}},debug:{type:Boolean,default:!1}},data:function(){return{namespace:"v-stepper",stepsArr:this.getMap(),index:this.toIndex(this.value)}},watch:{value:function(e){this.index=this.toIndex(e),this.persist&&this.setStorage()},index:{handler:function(e){this.$emit("input",this.toValue(e))},immediate:!0}},created:function(){if(this.persist){var e=this.getStorage();e?(this.stepsArr=e.stepsArr,this.index=e.index):this.setStorage()}},destroyed:function(){window[this.storekeeper].removeItem(this.id)},computed:{id:function(){return"".concat(this.namespace,"-").concat(this._uid)},lastIndex:function(){return this.stepsArr.length-1}},methods:{toValue:function(e){return e+1},toIndex:function(e){return e-1},doesStepExist:function(e){return!!this.stepsArr[e]},isIntermediateIndex:function(e){return e>0&&e<this.lastIndex},handleChange:function(e){var t=this,n=e===this.index+1,i=e===this.index-1,r=this.toIndex(this.value);this.linear?(n||i)&&(this.setStep(e,"active",!0),this.setStep(e,"visited",!1),this.setStep(e,"disabled",!1),this.setStep(r,"active",!1),this.setStep(r,"visited",!0),this.stepsArr.forEach(function(n){n.index>e&&t.setStep(n.index,"disabled",!0)}),this.$emit("input",this.toValue(e))):(this.setStep(r,"visited",!0),this.$emit("input",this.toValue(e)))},getMap:function(){var e=this;return Array.from(Array(this.steps),function(t,n){var i=0===n,r=n-1==0,o=!1;e.linear&&(i||r||(o=!0));return{index:n,value:e.toValue(n),visited:!1,disabled:o}})},offset:function(e){var t=this.index+e;this.doesStepExist(t)&&this.handleChange(t)},next:function(){this.offset(1)},previous:function(){this.offset(-1)},reset:function(){this.stepsArr=this.getMap(),this.index=0,this.$emit("reset")},setStep:function(e,t,n){this.$set(this.stepsArr[e],t,n)},setStorage:function(){var e=this.index,t=this.stepsArr;window[this.storekeeper].setItem(this.id,JSON.stringify({index:e,stepsArr:t}))},getStorage:function(){return JSON.parse(window[this.storekeeper].getItem(this.id))}},inheritAttrs:!1};t.default=a},function(e,t,n){"use strict";n.r(t);var i=n(7),r=n.n(i);for(var o in i)"default"!==o&&function(e){n.d(t,e,function(){return i[e]})}(o);t.default=r.a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={name:"VStepperRoot"}},function(e,t,n){var i=n(23);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(15).default)("6df4be32",i,!1,{})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t){for(var n=[],i={},r=0;r<t.length;r++){var o=t[r],a=o[0],s=o[1],u=o[2],d=o[3],f={id:e+":"+r,css:s,media:u,sourceMap:d};i[a]?i[a].parts.push(f):n.push(i[a]={id:a,parts:[f]})}return n}},function(e,t,n){"use strict";var i=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["v-step",e.classes]},[n("input",{directives:[{name:"show",rawName:"v-show",value:e.debug,expression:"debug"}],staticClass:"input",attrs:{type:"radio",id:e.id,name:e.computedName},domProps:{checked:e.active},on:{change:e.handleChange}}),e._v(" "),n("label",{staticClass:"label",attrs:{for:e.id}},[n("span",{staticClass:"index"},[e._t("index",[e._v("\n        "+e._s(e.api.displayIndex)+"\n      ")],null,e.api)],2),e._v(" "),e.defaultSlot?n("span",{staticClass:"title"},[e._t("default",null,null,e.api)],2):e._e(),e._v(" "),e.withDivider?n("span",{staticClass:"divider"}):e._e()])])},r=[];i._withStripped=!0,n.d(t,"a",function(){return i}),n.d(t,"b",function(){return r})},function(e,t,n){"use strict";var i=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"v-stepper"},[n(e.rootComponent,{tag:"component"},e._l(e.stepsArr,function(t,i){return n("v-step",{key:i,attrs:{name:e.id,debug:e.debug,index:i,visited:t.visited,disabled:t.disabled,"with-divider":e.withDivider,active:t.index===e.toIndex(e.value)},on:{change:e.handleChange},scopedSlots:e._u([{key:"index",fn:function(t){return[e._t("step-"+t.displayIndex+"-index",[e._v("\n          "+e._s(t.displayIndex)+"\n        ")],null,t)]}},{key:"default",fn:function(t){return[e._t("step-"+t.displayIndex,null,null,t)]}}])})}))],1)},r=[];i._withStripped=!0,n.d(t,"a",function(){return i}),n.d(t,"b",function(){return r})},function(e,t,n){"use strict";var i=function(){var e=this.$createElement;return(this._self._c||e)("div",{staticClass:"v-stepper-root"},[this._t("default")],2)},r=[];i._withStripped=!0,n.d(t,"a",function(){return i}),n.d(t,"b",function(){return r})},function(e,t,n){"use strict";n.r(t);var i=n(10),r=n(1);for(var o in r)"default"!==o&&function(e){n.d(t,e,function(){return r[e]})}(o);n(19);var a=n(0),s=Object(a.a)(r.default,i.a,i.b,!1,null,"1a92c248",null);s.options.__file="src\\components\\Step.vue",t.default=s.exports},function(e,t,n){"use strict";e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var n=function(e,t){var n=e[1]||"",i=e[3];if(!i)return n;if(t&&"function"==typeof btoa){var r=function(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}(i),o=i.sources.map(function(e){return"/*# sourceURL="+i.sourceRoot+e+" */"});return[n].concat(o).concat([r]).join("\n")}return[n].join("\n")}(t,e);return t[2]?"@media "+t[2]+"{"+n+"}":n}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var i={},r=0;r<this.length;r++){var o=this[r][0];"number"==typeof o&&(i[o]=!0)}for(r=0;r<e.length;r++){var a=e[r];"number"==typeof a[0]&&i[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(e,t,n){"use strict";n.r(t),n.d(t,"default",function(){return h});var i=n(9),r=n.n(i),o="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!o)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var a={},s=o&&(document.head||document.getElementsByTagName("head")[0]),u=null,d=0,f=!1,c=function(){},l=null,p="data-vue-ssr-id",v="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function h(e,t,n,i){f=n,l=i||{};var o=r()(e,t);return m(o),function(t){for(var n=[],i=0;i<o.length;i++){var s=o[i];(u=a[s.id]).refs--,n.push(u)}t?m(o=r()(e,t)):o=[];for(i=0;i<n.length;i++){var u;if(0===(u=n[i]).refs){for(var d=0;d<u.parts.length;d++)u.parts[d]();delete a[u.id]}}}}function m(e){for(var t=0;t<e.length;t++){var n=e[t],i=a[n.id];if(i){i.refs++;for(var r=0;r<i.parts.length;r++)i.parts[r](n.parts[r]);for(;r<n.parts.length;r++)i.parts.push(y(n.parts[r]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{var o=[];for(r=0;r<n.parts.length;r++)o.push(y(n.parts[r]));a[n.id]={id:n.id,refs:1,parts:o}}}}function b(){var e=document.createElement("style");return e.type="text/css",s.appendChild(e),e}function y(e){var t,n,i=document.querySelector("style["+p+'~="'+e.id+'"]');if(i){if(f)return c;i.parentNode.removeChild(i)}if(v){var r=d++;i=u||(u=b()),t=g.bind(null,i,r,!1),n=g.bind(null,i,r,!0)}else i=b(),t=function(e,t){var n=t.css,i=t.media,r=t.sourceMap;i&&e.setAttribute("media",i);l.ssrId&&e.setAttribute(p,t.id);r&&(n+="\n/*# sourceURL="+r.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");if(e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}.bind(null,i),n=function(){i.parentNode.removeChild(i)};return t(e),function(i){if(i){if(i.css===e.css&&i.media===e.media&&i.sourceMap===e.sourceMap)return;t(e=i)}else n()}}var x=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}();function g(e,t,n,i){var r=n?"":i.css;if(e.styleSheet)e.styleSheet.cssText=x(t,r);else{var o=document.createTextNode(r),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(o,a[t]):e.appendChild(o)}}},function(e,t,n){"use strict";n.r(t);var i=n(12),r=n(6);for(var o in r)"default"!==o&&function(e){n.d(t,e,function(){return r[e]})}(o);n(22);var a=n(0),s=Object(a.a)(r.default,i.a,i.b,!1,null,"5f0719f3",null);s.options.__file="src\\components\\StepperRoot.vue",t.default=s.exports},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"VStep",{enumerable:!0,get:function(){return i.default}}),Object.defineProperty(t,"VStepper",{enumerable:!0,get:function(){return r.default}}),Object.defineProperty(t,"VStepperRoot",{enumerable:!0,get:function(){return o.default}}),t.default=t.Install=void 0;var i=a(n(13)),r=a(n(21)),o=a(n(16));function a(e){return e&&e.__esModule?e:{default:e}}var s,u={install:function(e){e.component(i.default.name,i.default),e.component(r.default.name,r.default),e.component(o.default.name,o.default)}};t.Install=u,"undefined"!=typeof window?s=window.Vue:void 0!==e&&(s=e.Vue),s&&s.use(u);var d=r.default;t.default=d}).call(this,n(18))},function(e,t,n){"use strict";function i(e){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(e){"object"===("undefined"==typeof window?"undefined":i(window))&&(r=window)}e.exports=r},function(e,t,n){"use strict";var i=n(3);n.n(i).a},function(e,t,n){(e.exports=n(14)(!1)).push([e.i,"\n.v-step[data-v-1a92c248] {\n  flex: 1;\n  opacity: 0.55;\n  box-sizing: border-box;\n  transition: opacity 0.7s;\n}\n.v-step[data-v-1a92c248]:hover:not(.is-disabled) {\n    opacity: 0.85;\n}\n.v-step *[data-v-1a92c248],\n  .v-step *[data-v-1a92c248]::before,\n  .v-step *[data-v-1a92c248]::after {\n    box-sizing: inherit;\n}\n.v-step.is-active .label[data-v-1a92c248], .v-step.is-visited .label[data-v-1a92c248] {\n    cursor: pointer;\n}\n.v-step.is-active .index[data-v-1a92c248], .v-step.is-visited .index[data-v-1a92c248] {\n    color: #999999;\n}\n.v-step.is-active[data-v-1a92c248] {\n    opacity: 1;\n}\n.v-step.is-active .label .index[data-v-1a92c248] {\n      background-color: #ffffff;\n}\n.v-step.is-visited .index[data-v-1a92c248] {\n    background-color: #ffffff;\n}\n@media (max-width: 575px) {\n.v-step[data-v-1a92c248] {\n      margin-right: 0.5rem;\n}\n}\n.label[data-v-1a92c248] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.index[data-v-1a92c248] {\n  width: 3.5rem;\n  height: 3.5rem;\n  display: flex;\n  flex-shrink: 0;\n  font-size: 1.5rem;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n  color: #ffffff;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  border: 1px solid #f4f4f4;\n  box-shadow: 0.25rem 0.25rem 0.5rem rgba(0, 0, 0, 0.25);\n}\n.title[data-v-1a92c248] {\n  color: #ffffff;\n}\n.divider[data-v-1a92c248] {\n  width: 100%;\n  margin-left: 0.5rem;\n  border-bottom: 1px solid #ffffff;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n}\n",""])},function(e,t,n){"use strict";n.r(t);var i=n(11),r=n(4);for(var o in r)"default"!==o&&function(e){n.d(t,e,function(){return r[e]})}(o);var a=n(0),s=Object(a.a)(r.default,i.a,i.b,!1,null,null,null);s.options.__file="src\\components\\Stepper.vue",t.default=s.exports},function(e,t,n){"use strict";var i=n(8);n.n(i).a},function(e,t,n){(e.exports=n(14)(!1)).push([e.i,"\n.v-stepper-root[data-v-5f0719f3] {\n  display: flex;\n  width: inherit;\n  user-select: none;\n  box-sizing: border-box;\n  justify-content: space-between;\n}\n.v-stepper-root *[data-v-5f0719f3],\n  .v-stepper-root *[data-v-5f0719f3]::before,\n  .v-stepper-root *[data-v-5f0719f3]::after {\n    box-sizing: inherit;\n}\n",""])}])});

/***/ }),

/***/ "CgKE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LDf2":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-js\">import { VStepper } from &#39;vue-stepper-component&#39;\n\nexport default {\n  components: {\n    VStepper\n  },\n  data: () =&gt; ({ steps: 3, step: undefined })\n}\n</code></pre>\n";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25055e59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PwEp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25055e59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: 'UA-48463434-4'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OjZm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anchor_vue__ = __webpack_require__("qxq2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d2f4c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anchor_vue__ = __webpack_require__("aL4v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anchor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d2f4c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anchor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PVon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Docs_vue__ = __webpack_require__("0ZYP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44df0753_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Docs_vue__ = __webpack_require__("mqDy");
function injectStyle (ssrContext) {
  __webpack_require__("CgKE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Docs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44df0753_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Docs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PwEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Docs__ = __webpack_require__("PVon");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Docs',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Docs__["a" /* default */]
  }]
}));

/***/ }),

/***/ "aL4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"v-a",attrs:{"href":_vm.href,"target":_vm.computedTarget,"tabindex":_vm.tabindex},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eVP5":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-js\">import path from &#39;path&#39;\nimport router from &#39;./router&#39;\n\nimport { VStepper } from &#39;vue-stepper-component&#39;\n\nexport default {\n  components: {\n    VStepper\n  },\n  watch: {\n    $route: { \n      handler(route) {\n        this.changeRoute(route)\n      },\n      immediate: true\n    }\n  },\n  computed: {\n    ...mapGetters({\n      steps: types.STEPS,\n      step: types.STEP\n    }),\n    step: {\n      get() {\n        return this.step\n      },\n      set(step: route) {\n        this.changeRoute({ name: route })\n      }\n    }\n  },\n  methods: {\n    changeRoute(route) {\n      const basename = route.name || path.basename(route.fullPath)\n\n      router.push(basename)\n    }\n  }\n}\n</code></pre>\n";

/***/ }),

/***/ "mqDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs"},[_c('v-breakpoint',{model:{value:(_vm.model.breakpoint),callback:function ($$v) {_vm.$set(_vm.model, "breakpoint", $$v)},expression:"model.breakpoint"}}),_vm._v(" "),_c('div',{staticClass:"docs-container docs-container--has-jumbotron docs-100vh js-vh-fix"},[_c('div',{staticClass:"container docs-jumbotron"},[_c('h1',{staticClass:"docs-h1 mb-3"},[_vm._v("\n        Vue-Stepper "),_c('sup',{staticClass:"docs-version"},[_vm._v(_vm._s(_vm.pkg.version))])]),_vm._v(" "),_c('p',{staticClass:"docs-tagline mb-5"},[_vm._v("\n        Fully customizable\n        Stepper component "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.breakpoint.noMatch),expression:"model.breakpoint.noMatch"}]}),_vm._v(" with Vuex\n        support and Zero dependencies.\n      ")]),_vm._v(" "),_c('v-stepper',{ref:"stepper",staticClass:"docs-stepper mb-3",attrs:{"steps":_vm.model.steps,"debug":_vm.flags.debug,"linear":_vm.flags.linear,"persist":_vm.flags.persist},model:{value:(_vm.model.step),callback:function ($$v) {_vm.$set(_vm.model, "step", $$v)},expression:"model.step"}},[_c('template',{slot:"step-1"},[_vm._v(" Eeny ")]),_vm._v(" "),_c('template',{slot:"step-2"},[_vm._v(" Miny ")]),_vm._v(" "),_c('template',{slot:"step-3"},[_vm._v(" Moe ")])],2),_vm._v(" "),(_vm.model.step === 1)?[_c('p',{staticClass:"docs-lorem"},[_vm._v("\n          "+_vm._s(_vm.einyLorem)+"\n        ")])]:_vm._e(),_vm._v(" "),(_vm.model.step === 2)?[_c('p',{staticClass:"docs-lorem"},[_vm._v("\n          "+_vm._s(_vm.minyLorem)+"\n        ")])]:_vm._e(),_vm._v(" "),(_vm.model.step === 3)?[_c('p',{staticClass:"docs-lorem"},[_vm._v("\n          "+_vm._s(_vm.moeLorem)+"\n        ")])]:_vm._e(),_vm._v(" "),_c('v-hide-at',{attrs:{"no-match":""}},[_c('div',{staticClass:"docs-button-group mt-3"},[_c('button',{staticClass:"btn docs-button",on:{"click":function($event){_vm.$refs.stepper.previous()}}},[_vm._v("Previous")]),_vm._v(" "),_c('button',{staticClass:"btn docs-button",on:{"click":function($event){_vm.$refs.stepper.next()}}},[_vm._v("Next")]),_vm._v(" "),_c('button',{staticClass:"btn docs-button",on:{"click":function($event){_vm.$refs.stepper.reset()}}},[_vm._v("Reset")])])]),_vm._v(" "),_c('v-a',{staticClass:"docs-fixed-anchor docs-c-pointer",attrs:{"scroll-to":_vm.$refs.docs}},[_vm._v("\n        Install, Examples & Documentation\n      ")]),_vm._v(" "),_c('div',{staticClass:"docs-github-star"},[_c('a',{staticClass:"github-button",attrs:{"href":_vm.flags.production && _vm.pkg.repository.url,"data-icon":"octicon-star","data-show-count":"true","aria-label":"Star adi518/vue-stepper-component on GitHub"}},[_vm._v("\n          Star\n        ")])])],2)]),_vm._v(" "),_c('div',{ref:"docs",staticClass:"docs-container docs-min-100vh"},[_c('div',{staticClass:"container docs-clearfix"},[_c('h4',{ref:"install",staticClass:"mt-4"},[_c('v-a',{attrs:{"scroll-to":_vm.$refs.install}},[_vm._v("Install")])],1),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.install)}}),_vm._v(" "),_c('h4',{ref:"usage"},[_c('v-a',{attrs:{"scroll-to":_vm.$refs.usage}},[_vm._v("Usage")])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h5',[_vm._v("Template")]),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.examples.default.template)}}),_vm._v(" "),_c('h5',[_vm._v("Script")]),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.examples.default.script)}}),_vm._v(" "),_c('h4',{ref:"vuex"},[_c('v-a',{attrs:{"scroll-to":_vm.$refs.vuex}},[_vm._v("Vuex")])],1),_vm._v(" "),_c('p',[_vm._v("A common practice for managing your Stepper state, is through a Store.")]),_vm._v(" "),_c('h5',[_vm._v("Store")]),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.examples.vuex.meta)}}),_vm._v(" "),_c('h5',[_vm._v("Template")]),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.examples.vuex.component.template)}}),_vm._v(" "),_c('h5',[_vm._v("Script")]),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.examples.vuex.component.script)}}),_vm._v(" "),_c('h4',{ref:"programmatic"},[_c('v-a',{attrs:{"scroll-to":_vm.$refs.programmatic}},[_vm._v("Programmatic")])],1),_vm._v(" "),_c('p',[_vm._v("\n        Start off by assigning special\n        "),_c('code',[_vm._v("Vue")]),_vm._v(" property\n        "),_c('code',[_c('v-a',{attrs:{"href":"https://vuejs.org/v2/api/#ref"}},[_vm._v("ref")])],1),_vm._v(" to the\n        "),_c('code',[_vm._v("v-stepper")]),_vm._v(" component. Then, assign an API method to an Event listener\n        of your choice. The following example is similar to the Demo above, where we assign\n        "),_c('code',[_vm._v("previous")]),_vm._v(", "),_c('code',[_vm._v("next")]),_vm._v(" and "),_c('code',[_vm._v("reset")]),_vm._v(" to the\n        "),_c('code',[_vm._v("click")]),_vm._v(" event of a button element.\n      ")]),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.examples.programmatic.template)}}),_vm._v(" "),_c('h4',{ref:"api-props"},[_c('v-a',{attrs:{"scroll-to":_vm.$refs['api-props']}},[_vm._v("API Props")])],1),_vm._v(" "),_c('div',{staticClass:"docs-markdown",domProps:{"innerHTML":_vm._s(_vm.markdowns.props)}}),_vm._v(" "),_c('h4',{ref:"support"},[_c('v-a',{attrs:{"scroll-to":_vm.$refs.support}},[_vm._v("Support")])],1),_vm._v(" "),_c('p',[_vm._v("\n        Please open an\n        "),_c('v-a',{attrs:{"href":_vm.pkg.bugs.url}},[_vm._v("issue")]),_vm._v(" for support.\n      ")],1),_vm._v(" "),_c('h4',{ref:"license",staticClass:"mt-5"},[_c('v-a',{attrs:{"scroll-to":_vm.$refs.license}},[_vm._v("License")])],1),_vm._v(" "),_c('p',[_vm._v("\n        Copyright (c) 2018\n        "),_c('v-a',{attrs:{"href":"https://github.com/adi518"}},[_vm._v("\n          "+_vm._s(_vm.pkg.author)+"\n        ")]),_vm._v("\n        by\n        "),_c('v-a',{attrs:{"href":"https://opensource.org/licenses/MIT"}},[_vm._v("\n          "+_vm._s(_vm.pkg.license)+"\n        ")])],1)])]),_vm._v(" "),_c('footer',{staticClass:"docs-footer docs-clearfix"},[_c('p',{staticClass:"docs-credit mt-2 mb-2"},[_vm._v("\n      Made with ❤️ by\n      "),_c('v-a',{attrs:{"href":"https://github.com/adi518"}},[_vm._v("\n        Adi Sahar\n      ")])],1)]),_vm._v(" "),_c('v-a',{staticClass:"docs-github",attrs:{"href":_vm.pkg.repository.url}},[_c('img',{attrs:{"src":_vm.assets.octocat,"alt":"Github"}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        To use the component in your templates, simply import and register with your component.\n        To control the Stepper state, we use the "),_c('code',[_vm._v("v-model")]),_vm._v(" directive, just like on any\n        other input element with two-way binding. The Stepper acts as a group of radio-buttons.\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qxq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VA',
  props: {
    name: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    tabindex: {
      type: String,
      default: ''
    },
    refs: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    scrollTo: {
      type: [String, Element],
      default: ''
    },
    target: {
      type: String,
      default: '_blank'
    },
    prevent: {
      type: Boolean,
      default: false
    },
    static: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedTarget: function computedTarget() {
      if (this.scrollTo) {
        return undefined;
      }
      return this.target;
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      if (this.prevent || this.scrollTo || this.static) {
        event.preventDefault();
      }

      if (this.scrollTo) {
        this.$scrollTo(this.scrollTo);
      }

      this.$emit('click', { href: this.href });
    },
    getElementByRef: function getElementByRef(ref, refs) {
      refs = refs || this.$refs;

      var noRefs = !refs;

      if (noRefs) {
        console.error('[getElementByRef warn]: No refs found.');
        return;
      }

      var element = refs[ref];

      // Is from element?
      if (element instanceof Element) {
        return element;
      }

      // Is from component?
      if (refs[ref]) {
        element = refs[ref].el;
        if (element instanceof Element) {
          return element;
        }
      }

      // Ref doesn't exist
      console.error('[getElementByRef warn]: No such ref as "' + ref + '".');

      return null;
    },
    $scrollTo: function $scrollTo(ref) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var element = void 0;

      if (ref instanceof Element) {
        element = ref;
      } else {
        element = this.getElementByRef(ref, this.refs);
      }

      if (element) {
        element.scrollIntoView(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          behavior: 'smooth',
          block: 'start'
        }, options));
      }
    }
  }
});

/***/ }),

/***/ "xC3h":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-js\">// State\nconst state = { steps: 3, step: undefined }\n\n// Getters...\n// Mutations...\n\n// Export\n</code></pre>\n";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "yP6i":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-html\">&lt;v-stepper :steps=&quot;steps&quot; v-model=&quot;step&quot;&gt;&lt;/v-stepper&gt;\n\n&lt;template v-if=&quot;step === 1&quot;&gt;&lt;!-- Step 1 Content --&gt;&lt;/template&gt;\n&lt;template v-if=&quot;step === 2&quot;&gt;&lt;!-- Step 2 Content --&gt;&lt;/template&gt;\n&lt;template v-if=&quot;step === 3&quot;&gt;&lt;!-- Step 3 Content --&gt;&lt;/template&gt;\n\n&lt;!-- etc&#39; --&gt;\n</code></pre>\n";

/***/ }),

/***/ "yypm":
/***/ (function(module, exports) {

module.exports = "<pre><code class=\"lang-bash\">$ npm install vue-stepper-component --save\n</code></pre>\n";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5bcea501ef7dbe27d73c.js